import { DefaultApi } from '@sendhub/integrations/api-client-typescript-axios'
import axios, { AxiosRequestConfig, isAxiosError } from 'axios'
import Cookies from 'js-cookie'
import { INTEGRATIONS_BASE_URL } from '../../utils/config'

/**
 * A client for the Zapier operations that authenticate with a *Zapier* access
 * token (`Zapier_Access_Token` in openapi.yaml: /zapier/zaps, /zapier/profiles/me).
 * Callers pass that token per request; this instance deliberately holds no
 * credential of ours.
 *
 * Zapier operations under our own JWT security (listZapierTemplates,
 * listZapierApps) do NOT belong here — use `integrationsApi`, which carries the
 * bearer token and refreshes it on 401. A bare instance can't do either, and
 * cookie auth is not available cross-site (see utils/token-store.ts).
 */
export function createZapierApiClient(bypassProxy?: boolean) {
  const axiosInstance = axios.create({
    withCredentials: true,
  })
  if (bypassProxy)
    axiosInstance.interceptors.request.use((requestConfig) => ({
      ...requestConfig,
      url: (requestConfig?.url || '').replace(/\/zapier/, ''),
      params: { ...requestConfig.params, client_id: 'XXXXXX' },
    }))

  const basePath = bypassProxy ? `https://api.zapier.com/v1` : `${INTEGRATIONS_BASE_URL}/api/v2`

  return new DefaultApi(undefined, basePath, axiosInstance)
}

export const zapierApi = createZapierApiClient()
